import React from 'react';
import { SectionTitle } from './SectionTitle';
import { painQuestions, painSection } from '../data/salesCopy';
export function PainSection() {
  return <section className="bg-brand-ivory px-4 py-7 sm:py-9" data-id="element-179" data-mp="38vu7s8uzq744">
      <div className="mx-auto max-w-3xl" data-id="element-180" data-mp="2ux40y1idct2k">
        <SectionTitle data-id="element-181" data-mp="2v08ehphq515w">😰 {painSection.heading}</SectionTitle>

        <div className="mt-4 space-y-1 text-center text-[13px] font-medium leading-snug text-brand-charcoal/85 sm:text-[15px]" data-id="element-182" data-mp="2yyfswdoptqdx">
          {painSection.intro.map(line => <p key={line} data-id="element-183" data-mp="2pzkj6rmgpy5v">{line}</p>)}
        </div>

        <ul className="mt-4 grid gap-1.5 sm:grid-cols-2" data-id="element-184" data-mp="2q0vq30b7fm17">
          {painQuestions.map(q => <li key={q} className="rounded border-l-2 border-brand-clay bg-white px-3 py-2 text-[12.5px] font-semibold italic leading-snug text-brand-charcoal/90 shadow-sm sm:text-[13.5px]" data-id="element-185" data-mp="2b8bow57m7ome">
              “{q}”
            </li>)}
        </ul>

        <div className="mt-4 space-y-1 text-center text-[13px] font-semibold leading-snug text-brand-charcoal sm:text-[15px]" data-id="element-186" data-mp="27anownr2f5nn">
          {painSection.outro.map(line => <p key={line} data-id="element-187" data-mp="3nkw1kphcc3m4">{line}</p>)}
        </div>
      </div>
    </section>;
}